const OverviewTab = ({ 
  getRecentActivity, 
  getStatusBadge, 
  setActiveTab, 
  absences, 
  trainings, 
  offers, 
  itTickets, 
  darkMode 
}) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-slate-800'}`}>Atividade Recente</h3>
        <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Últimas {getRecentActivity().length} atividades</p>
      </div>
      
      {getRecentActivity().length === 0 ? (
        <div className="text-center py-12">
          <span className="text-5xl block mb-4">📋</span>
          <p className={`mb-2 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Sem atividade recente</p>
          <p className={`text-sm ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>As suas ações e registos aparecerão aqui</p>
        </div>
      ) : (
        <div className="space-y-3">
          {getRecentActivity().map((activity, idx) => (
            <div 
              key={idx} 
              className={`flex items-center justify-between p-4 rounded-lg transition-colors cursor-pointer ${
                darkMode ? 'bg-slate-700/50 hover:bg-slate-700' : 'bg-slate-100 hover:bg-slate-200'
              }`}
              onClick={() => {
                const tabMap = {
                  'absence': 'absences',
                  'training': 'trainings',
                  'offer': 'offers',
                  'ticket': 'it-tickets',
                  'fine': 'fines',
                  'km_log': 'vehicles'
                };
                if (tabMap[activity.type]) {
                  setActiveTab(tabMap[activity.type]);
                }
              }}
            >
              <div className="flex items-center gap-4">
                <span className="text-2xl">{activity.icon}</span>
                <div>
                  <p className={darkMode ? 'text-white font-medium' : 'text-slate-800 font-medium'}>{activity.title}</p>
                  <p className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>{activity.description}</p>
                  {activity.date && (
                    <p className={`text-xs mt-1 ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
                      {new Date(activity.date).toLocaleDateString('pt-PT', { 
                        day: 'numeric', 
                        month: 'short',
                        year: 'numeric'
                      })}
                    </p>
                  )}
                </div>
              </div>
              {getStatusBadge(activity.status)}
            </div>
          ))}
        </div>
      )}

      {/* Quick Stats Summary */}
      <div className={`mt-8 pt-6 border-t ${darkMode ? 'border-slate-700' : 'border-slate-200'}`}>
        <h4 className={`text-lg font-semibold mb-4 ${darkMode ? 'text-white' : 'text-slate-800'}`}>Resumo Rápido</h4>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className={`rounded-lg p-4 text-center ${darkMode ? 'bg-slate-700/30' : 'bg-slate-100'}`}>
            <p className="text-3xl font-bold text-emerald-400">{absences.filter(a => a.status === 'hr_approved').length}</p>
            <p className={`text-xs mt-1 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Ausências Aprovadas</p>
          </div>
          <div className={`rounded-lg p-4 text-center ${darkMode ? 'bg-slate-700/30' : 'bg-slate-100'}`}>
            <p className="text-3xl font-bold text-amber-400">{trainings.filter(t => t.status !== 'completed').length}</p>
            <p className={`text-xs mt-1 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Formações Pendentes</p>
          </div>
          <div className={`rounded-lg p-4 text-center ${darkMode ? 'bg-slate-700/30' : 'bg-slate-100'}`}>
            <p className="text-3xl font-bold text-blue-400">{offers.length}</p>
            <p className={`text-xs mt-1 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Ofertas Declaradas</p>
          </div>
          <div className={`rounded-lg p-4 text-center ${darkMode ? 'bg-slate-700/30' : 'bg-slate-100'}`}>
            <p className="text-3xl font-bold text-purple-400">{itTickets.filter(t => t.status === 'open').length}</p>
            <p className={`text-xs mt-1 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Tickets Abertos</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
